import ActivityDetailsController from "../../source/js/controllers/ActivityDetailsController.js";
import BottomSheetController from "../../source/js/controllers/BottomSheetController.js";
import CopyController from "../../source/js/controllers/CopyController.js";
import MenuController from "../../source/js/controllers/MenuController.js";
import NoteLimitController from "../../source/js/controllers/NoteLimitController.js";
import NotificationController from "../../source/js/controllers/NotificationController.js";
import PinController from "../../source/js/controllers/PinController.js";
import ProcessTransferController from "../../source/js/controllers/ProcessTransferController.js";
import PullToRefreshController from "../../source/js/controllers/PullToRefreshController.js";
import PwaController from "../../source/js/controllers/PwaController.js";
import PwaOpenerController from "../../source/js/controllers/PwaOpenerController.js";
import QRCodeController from "../../source/js/controllers/QRCodeController.js";
import QrToggleController from "../../source/js/controllers/QrToggleController.js";
import ReturnToStoreController from "../../source/js/controllers/ReturnToStoreController.js";
import SessionController from "../../source/js/controllers/SessionController.js";
import SocketController from "../../source/js/controllers/SocketController.js";
import TransactionHistoryController from "../../source/js/controllers/TransactionHistoryController.js";
import WebviewController from "../../source/js/controllers/WebviewController.js";
import actionDispatchController from "../../source/js/controllers/actionDispatchController.js";
import addressBookController from "../../source/js/controllers/addressBookController.js";
import cardPreviewController from "../../source/js/controllers/cardPreviewController.js";
import cashOrderAmountController from "../../source/js/controllers/cashOrderAmountController.js";
import cashPasskeyController from "../../source/js/controllers/cashPasskeyController.js";
import cashRevealController from "../../source/js/controllers/cashRevealController.js";
import checkoutDepositEmbedController from "../../source/js/controllers/checkoutDepositEmbedController.js";
import createPasskeyController from "../../source/js/controllers/createPasskeyController.js";
import cryptoSelectAssetController from "../../source/js/controllers/cryptoSelectAssetController.js";
import datePickerController from "../../source/js/controllers/datePickerController.js";
import depositBestRouteController from "../../source/js/controllers/depositBestRouteController.js";
import depositSuccessController from "../../source/js/controllers/depositSuccessController.js";
import depositWalletController from "../../source/js/controllers/depositWalletController.js";
import embedController from "../../source/js/controllers/embedController.js";
import feeBreakdownController from "../../source/js/controllers/feeBreakdownController.js";
import formSubmitController from "../../source/js/controllers/formSubmitController.js";
import formValidationController from "../../source/js/controllers/formValidationController.js";
import invoiceUploadController from "../../source/js/controllers/invoiceUploadController.js";
import loginController from "../../source/js/controllers/loginController.js";
import maxAmountController from "../../source/js/controllers/maxAmountController.js";
import meldCompareController from "../../source/js/controllers/meldCompareController.js";
import meldConfirmController from "../../source/js/controllers/meldConfirmController.js";
import meldDepositController from "../../source/js/controllers/meldDepositController.js";
import modalButtonController from "../../source/js/controllers/modalButtonController.js";
import modalController from "../../source/js/controllers/modalController.js";
import moneyController from "../../source/js/controllers/moneyController.js";
import otpController from "../../source/js/controllers/otpController.js";
import pasteWalletAddressController from "../../source/js/controllers/pasteWalletAddressController.js";
import pushToCardSendingController from "../../source/js/controllers/pushToCardSendingController.js";
import regionSelectController from "../../source/js/controllers/regionSelectController.js";
import removeBankAccountController from "../../source/js/controllers/removeBankAccountController.js";
import removePasskeyController from "../../source/js/controllers/removePasskeyController.js";
import rewardsTabsController from "../../source/js/controllers/rewardsTabsController.js";
import scanController from "../../source/js/controllers/scanController.js";
import searchableSelectController from "../../source/js/controllers/searchableSelectController.js";
import selectController from "../../source/js/controllers/selectController.js";
import selectTriggerController from "../../source/js/controllers/selectTriggerController.js";
import sendController from "../../source/js/controllers/sendController.js";
import signWithPasskeyController from "../../source/js/controllers/signWithPasskeyController.js";
import sumsubTestKycController from "../../source/js/controllers/sumsubTestKycController.js";
import termsController from "../../source/js/controllers/termsController.js";
import themeToggleController from "../../source/js/controllers/themeToggleController.js";
import toastController from "../../source/js/controllers/toastController.js";
import toggleController from "../../source/js/controllers/toggleController.js";
import tooltipController from "../../source/js/controllers/tooltipController.js";
import withdrawCryptoConfirmationController from "../../source/js/controllers/withdrawCryptoConfirmationController.js";
import withdrawInitiatedController from "../../source/js/controllers/withdrawInitiatedController.js";
import ActiveLinkController from "../../source/js/controllers/utility/ActiveLinkController.js";
import AnalyticsController from "../../source/js/controllers/utility/AnalyticsController.js";
import BackgroundImageController from "../../source/js/controllers/utility/BackgroundImageController.js";
import BackgroundVideoController from "../../source/js/controllers/utility/BackgroundVideoController.js";
import ExpirationTimerController from "../../source/js/controllers/utility/ExpirationTimerController.js";
import PageTransitionController from "../../source/js/controllers/utility/PageTransitionController.js";
import PlatformController from "../../source/js/controllers/utility/PlatformController.js";
import TimezoneController from "../../source/js/controllers/utility/TimezoneController.js";
import ChartController from "../../../../global/controllers/ChartController.js";
import NumpadController from "../../../../global/controllers/NumpadController.js";
import PaginationController from "../../../../global/controllers/PaginationController.js";
import RobustTableController from "../../../../global/controllers/RobustTableController.js";
import ToastManagerController from "../../../../global/controllers/ToastManagerController.js";
import ToasterController from "../../../../global/controllers/ToasterController.js";
export default [
  { name: "ActivityDetailsController", controller: ActivityDetailsController },
  { name: "BottomSheetController", controller: BottomSheetController },
  { name: "CopyController", controller: CopyController },
  { name: "MenuController", controller: MenuController },
  { name: "NoteLimitController", controller: NoteLimitController },
  { name: "NotificationController", controller: NotificationController },
  { name: "PinController", controller: PinController },
  { name: "ProcessTransferController", controller: ProcessTransferController },
  { name: "PullToRefreshController", controller: PullToRefreshController },
  { name: "PwaController", controller: PwaController },
  { name: "PwaOpenerController", controller: PwaOpenerController },
  { name: "QRCodeController", controller: QRCodeController },
  { name: "QrToggleController", controller: QrToggleController },
  { name: "ReturnToStoreController", controller: ReturnToStoreController },
  { name: "SessionController", controller: SessionController },
  { name: "SocketController", controller: SocketController },
  { name: "TransactionHistoryController", controller: TransactionHistoryController },
  { name: "WebviewController", controller: WebviewController },
  { name: "actionDispatchController", controller: actionDispatchController },
  { name: "addressBookController", controller: addressBookController },
  { name: "cardPreviewController", controller: cardPreviewController },
  { name: "cashOrderAmountController", controller: cashOrderAmountController },
  { name: "cashPasskeyController", controller: cashPasskeyController },
  { name: "cashRevealController", controller: cashRevealController },
  { name: "checkoutDepositEmbedController", controller: checkoutDepositEmbedController },
  { name: "createPasskeyController", controller: createPasskeyController },
  { name: "cryptoSelectAssetController", controller: cryptoSelectAssetController },
  { name: "datePickerController", controller: datePickerController },
  { name: "depositBestRouteController", controller: depositBestRouteController },
  { name: "depositSuccessController", controller: depositSuccessController },
  { name: "depositWalletController", controller: depositWalletController },
  { name: "embedController", controller: embedController },
  { name: "feeBreakdownController", controller: feeBreakdownController },
  { name: "formSubmitController", controller: formSubmitController },
  { name: "formValidationController", controller: formValidationController },
  { name: "invoiceUploadController", controller: invoiceUploadController },
  { name: "loginController", controller: loginController },
  { name: "maxAmountController", controller: maxAmountController },
  { name: "meldCompareController", controller: meldCompareController },
  { name: "meldConfirmController", controller: meldConfirmController },
  { name: "meldDepositController", controller: meldDepositController },
  { name: "modalButtonController", controller: modalButtonController },
  { name: "modalController", controller: modalController },
  { name: "moneyController", controller: moneyController },
  { name: "otpController", controller: otpController },
  { name: "pasteWalletAddressController", controller: pasteWalletAddressController },
  { name: "pushToCardSendingController", controller: pushToCardSendingController },
  { name: "regionSelectController", controller: regionSelectController },
  { name: "removeBankAccountController", controller: removeBankAccountController },
  { name: "removePasskeyController", controller: removePasskeyController },
  { name: "rewardsTabsController", controller: rewardsTabsController },
  { name: "scanController", controller: scanController },
  { name: "searchableSelectController", controller: searchableSelectController },
  { name: "selectController", controller: selectController },
  { name: "selectTriggerController", controller: selectTriggerController },
  { name: "sendController", controller: sendController },
  { name: "signWithPasskeyController", controller: signWithPasskeyController },
  { name: "sumsubTestKycController", controller: sumsubTestKycController },
  { name: "termsController", controller: termsController },
  { name: "themeToggleController", controller: themeToggleController },
  { name: "toastController", controller: toastController },
  { name: "toggleController", controller: toggleController },
  { name: "tooltipController", controller: tooltipController },
  { name: "withdrawCryptoConfirmationController", controller: withdrawCryptoConfirmationController },
  { name: "withdrawInitiatedController", controller: withdrawInitiatedController },
  { name: "utility_ActiveLinkController", controller: ActiveLinkController },
  { name: "utility_AnalyticsController", controller: AnalyticsController },
  { name: "utility_BackgroundImageController", controller: BackgroundImageController },
  { name: "utility_BackgroundVideoController", controller: BackgroundVideoController },
  { name: "utility_ExpirationTimerController", controller: ExpirationTimerController },
  { name: "utility_PageTransitionController", controller: PageTransitionController },
  { name: "utility_PlatformController", controller: PlatformController },
  { name: "utility_TimezoneController", controller: TimezoneController },
  { name: "ChartController", controller: ChartController },
  { name: "NumpadController", controller: NumpadController },
  { name: "PaginationController", controller: PaginationController },
  { name: "RobustTableController", controller: RobustTableController },
  { name: "ToastManagerController", controller: ToastManagerController },
  { name: "ToasterController", controller: ToasterController }
];